module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_2.a7aa1574.png";